// src/Pages/VoterScan.js
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QrReader from "react-qr-scanner";
import axios from "axios";
import toast from "react-hot-toast";

const VoterScan = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [scanError, setScanError] = useState(null);
    const [isScanning, setIsScanning] = useState(false);
    const [qrData, setQrData] = useState(null);

    // Display error from location state if available.
    useEffect(() => {
        if (state && state.error) {
            setScanError(state.error);
        }
    }, [state]);

    const handleScan = async (data) => {
        if (data && !isScanning) {
            setIsScanning(true);
            console.log("Scanned data:", data);

            // Retrieve the scanned text.
            const scannedText = data.text || "";
            console.log("Scanned text:", scannedText);

            // In our design the QR code should contain "empId:electionId"
            setQrData(scannedText);

            try {
                // Call the backend verifyQR endpoint with the scanned payload.
                const response = await axios.get("https://backend.block-ballot.com/voters/verifyQR", {
                    params: { qrPayload: scannedText },
                });
                const voterDetails = response.data;
                console.log("Fetched voter details:", voterDetails);

                // Check if the voter has already voted.
                if (voterDetails.hasVoted) {
                    alert("Voter has already voted.");
                    navigate("/voterScan", { state: { error: "Voter has already voted" } });
                    return;
                }

                // Optionally delay for visual confirmation then navigate to the verified page.
                setTimeout(() => {
                    navigate("/VoterVerifiedPage", { state: { voterDetails } });
                }, 2000);
            } catch (error) {
                console.error("Error fetching voter details:", error);
                if (error.response && error.response.status === 400) {
                    setScanError("Voter has already voted.");
                } else {
                    setScanError("Error retrieving voter details. Please try again.");
                }
                setIsScanning(false); // Allow re-scanning on error.
            }
        }
    };

    const handleError = (err) => {
        console.error("QR Scan Error:", err);
        setScanError("Could not access camera or read QR code.");
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen w-screen bgColor text-white relative font-[Montserrat]">
            {/* Cancel Button */}
            <div
                className="absolute top-5 left-5 text-lg text-black cursor-pointer font-semibold"
                onClick={() => navigate("/QRScanPage")}
            >
                Cancel
            </div>

            {/* Instruction */}
            <p className="text-sm text-gray-400 mb-6 text-center">
                Please scan the QR code sent to your email.
            </p>

            {/* Error Message */}
            {scanError && <p className="text-red-500 text-sm mt-2">{scanError}</p>}

            {/* Display confirmation UI if QR data exists, otherwise show the QR scanner */}
            {qrData ? (
                <div className="flex flex-col items-center bg-white text-black p-5 rounded-lg shadow-lg w-96">
                    <p className="text-center font-semibold text-lg">
                        QR Code Scanned Successfully
                    </p>
                    <button
                        onClick={() =>
                            navigate("/VoterVerifiedPage", { state: { voterDetails: null } })
                        }
                        className="bg-green-500 text-white px-6 py-2 rounded-lg mt-4"
                    >
                        OK
                    </button>
                </div>
            ) : (
                <div className="relative w-[450px] h-[450px] flex items-center justify-center bg-gray-900 rounded-lg overflow-hidden mb-6">
                    <QrReader
                        delay={300}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        onError={handleError}
                        onScan={handleScan}
                    />
                </div>
            )}

            {/* Assistance Note */}
            <p className="absolute bottom-6 text-yellow-600 text-sm">
                ⚠️ If you didn’t receive the QR code or are facing issues, please contact an admin for assistance.
            </p>
        </div>
    );
};

export default VoterScan;
